import React from 'react';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Does this sound like you" className="border-y border-line bg-ink-2" data-id="element-146" data-mp="2lnu26to0xz3m">
      <div className="mx-auto max-w-4xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "8px"
    }} data-id="element-147" data-mp="26ypljgwvo2xm">
        <h2 className="text-center font-display text-3xl font-bold uppercase text-fog sm:text-4xl" data-id="element-148" data-mp="2bwzc1e7nqfcw">Does this sound like you?</h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-4 text-center text-[15px] leading-relaxed text-fog/75" data-id="element-149" data-mp="1xwyg8d691y4a">
          <p data-id="element-150" data-mp="220o0iqfw5tji">
            You take your security responsibilities seriously. You monitor sites, conduct patrols, document incidents,
            communicate with clients, coordinate handovers, and keep track of tasks that cannot simply be forgotten.
          </p>
          <p data-id="element-151" data-mp="3idbhm0ct6zii">But when the shift gets busy, documentation and administrative responsibilities can become difficult to organize.</p>
          <p data-id="element-152" data-mp="3nc5z8yz1ii11">
            You may find yourself starting reports from scratch, rewriting routine messages, or wondering how to use AI
            without receiving generic, disorganized responses.
          </p>
        </div>
        <p className="mx-auto mt-5 max-w-2xl text-center text-lg font-bold text-fog" data-id="element-153" data-mp="1tzrb8gwwt3fu">
          It's not a lack of experience. Sometimes you simply need a more{' '}
          <span className="text-teal" data-id="element-154" data-mp="23sopgauvc68n">structured framework</span>.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-155" data-mp="1g114sao79ret">
          {painPoints.map(p => <article key={p.title} className="flex flex-col rounded-2xl border border-line bg-ink p-5" data-id="element-156" data-mp="1b2zmvt2ify4x">
              <h3 className="flex items-start gap-2.5 text-base font-bold text-fog" data-id="element-157" data-mp="1p30lt2z7svhr">
                <span aria-hidden="true" data-id="element-158" data-mp="1k3ny6g0irke4">{p.emoji}</span>
                {p.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-fog/65" data-id="element-159" data-mp="30he3tr7aegpv">{p.problem}</p>
              <div className="mt-auto pt-4" data-id="element-160" data-mp="30jh1mxeole55">
                <p className="border-t border-line pt-3 text-sm font-medium leading-relaxed text-teal" data-id="element-161" data-mp="2vhjfnvewc58i">{p.answer}</p>
              </div>
            </article>)}
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-xl font-semibold text-fog sm:text-2xl" data-id="element-162" data-mp="1y3zupdyjosi6">
          ✨ If any of these sound familiar, <span className="text-gold" data-id="element-163" data-mp="226mo3jav6lhh">SIGMA SMART™</span> has developed a practical toolkit
          to help you approach them differently.
        </p>
      </div>
    </section>;
}